import React, { Component } from 'react'
import { connect } from 'react-redux'
import { basketActions } from '../../../actions/transactions/index';
import Basket from './Basket';

class BasketContainer extends Component {

    componentWillMount() {
        this.props.getBasket();
    };

    render() {

        const { basket, clearBasket, network } = this.props;
        
        return (
            <Basket
                items={ basket }
                clearBasket={ () => clearBasket() }
                network={ network }
            />
        );
    };
}

const mapStateToProps = ( state ) => ( {
    basket: state.transactions.basket,
} );

const mapDispatchToProps = ( dispatch ) => {
    return {
        // proceedToCheckout: ( products ) => dispatch( basketActions.proceedToCheckout( products ) ),
        getBasket: () => dispatch( basketActions.getBasket() ),
        clearBasket: () => dispatch( basketActions.clearBasket() ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( BasketContainer )



// WEBPACK FOOTER //
// src/client/components/common/transactions/BasketContainer.js